import { Search, X } from 'lucide-react';
import type { ReactNode } from 'react';

interface Props {
  value: string;
  onChange: (v: string) => void;
  /** The "+ Filter" builder, placed beside the input. */
  builderSlot?: ReactNode;
  /** Feed was auto-paused because the list is narrowed (search text or filter
   *  chips) — surfaced so the frozen list reads as deliberate, not as a dead
   *  stream. */
  autoPaused?: boolean;
}

/** Free-text search over the selected topic's messages. Column 2 — scoped to
 *  what the user is already inspecting, not the whole broker. */
export function MessageSearch({ value, onChange, builderSlot, autoPaused }: Props) {
  return (
    <div className="flex items-center gap-1.5 border-b border-(--color-border) bg-(--color-surface) px-2 py-[5px]">
      <div className="relative min-w-0 flex-1">
        <Search
          size={11}
          className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 opacity-40"
        />
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label="Search these messages"
          placeholder="Search these messages…"
          className="w-full rounded border border-(--color-border) bg-(--color-bg) py-[4px] pl-6 pr-6 font-mono text-[0.769em] text-(--color-text) outline-none focus:border-(--color-green)"
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            aria-label="Clear message search"
            className="absolute right-1 top-1/2 -translate-y-1/2 cursor-pointer rounded p-0.5 text-(--color-text3) hover:text-(--color-text)"
          >
            <X size={11} />
          </button>
        )}
      </div>
      {autoPaused && (
        <span
          title="Stream paused while the list is filtered — clear the search and filter chips to resume"
          className="shrink-0 rounded border border-(--color-amber) bg-(--color-amber-bg) px-1.5 py-[1px] font-sans text-[0.615em] font-bold uppercase tracking-wide text-(--color-amber)"
        >
          Paused
        </span>
      )}
      {builderSlot}
    </div>
  );
}
